<template>
	<div class="cont">
		<div v-for="key in Object.keys(localValue)" :key="key">
			<h3>{{ key }}</h3>
			<AppTextField v-model="localValue[key]" outlined />
		</div>
	</div>
</template>
<script>
import VModelMixin from '@/mixins/VModelMixin';

export default {
	name: 'URLToolTriggerParams',
	mixins: [VModelMixin],
};
</script>
<style scoped lang="scss">
.cont {
	max-height: 210px;
	overflow: auto;
}
</style>
